import styled from 'styled-components';
import bg from 'apps/BWW_PLAY_HUB/assets/img/cards/pp.png';

interface IEventCardPPHeader {
	isSmall?: boolean;
	image?: string | null
}

export const EventCardPPHeader = styled.div<IEventCardPPHeader>`
	min-height: ${props => props.isSmall ? '103px' : '215px'};
	background: url(${props => props.image || bg}) center bottom no-repeat transparent;
	background-size: cover;
	padding: 45px 10px 20px;
	box-sizing: border-box;
	position:relative;
	display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
`;
